import { GasStationOutlineIcon } from './GasStationOutlineIcon';

/**
 * author: Google
 * id E489326F-90B9-43E6-91CF-9123E914E84F
 * name gas-station-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gas-station-outline.svg
 * tags
 */
export const FuelStationOutlineIcon = GasStationOutlineIcon;
export default FuelStationOutlineIcon